<div class="mb-3">
  <div class="p-3 border border-dark">
    <form [formGroup]="departmentForm" id="department-form" >
      <div class="mb-3">
        <label for="deptId">Dept Org ID</label>
        <input id="deptId" type="text" class="form-control" aria-describedby="department ID" formControlName="departmentControl" name="deptId">
      </div>
    </form>
  </div>
  <app-warning *ngIf="!departmentForm.valid" [small]="true">
    <div>
      <p class="h5">Invalid Dept Org ID</p>
    </div>
  </app-warning>
</div>
